import React, { useRef, useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import StyleInput from "../../../components/Button/Input";
import StyleSelect from "../../../components/Button/AutoComplete";
import formtrans from "../../../translate/forms";
import tabletrans from "../../../translate/tables";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import env from "../../../env";
function UploadDetails(props) {
  const editorRef = useRef(null);
  const token = props.token;
  const content = props.content;

  return (
    <div className="serviceItem">
      <StyleInput
        title={formtrans.title[props.lang]}
        direction={props.direction}
        defaultValue={content ? content.title : ""}
        class={"formInput"}
        action={(e) =>
          props.setSliderChange((prevState) => ({
            ...prevState,
            title: e,
          }))
        }
      />
      <StyleInput
        title={"عنوان انگلیسی"}
        direction={props.direction}
        defaultValue={content ? content.enTitle : ""}
        class={"formInput"}
        action={(e) =>
          props.setSliderChange((prevState) => ({
            ...prevState,
            enTitle: e,
          }))
        }
      />
      <StyleInput
        title={"پوزیتشن"}
        direction={props.direction}
        defaultValue={content ? content.position : ""}
        class={"formInput"}
        action={(e) =>
          props.setSliderChange((prevState) => ({
            ...prevState,
            position: e,
          }))
        }
      />
      <StyleInput
        title={"لینک"}
        direction={props.direction}
        defaultValue={content ? content.link : ""}
        class={"formInput"}
        action={(e) =>
          props.setSliderChange((prevState) => ({
            ...prevState,
            link: e,
          }))
        }
      />
    </div>
  );
}
export default UploadDetails;
